import React from 'react';
import PropTypes from 'prop-types';
import css from './ItemTitle.desktop.scss';
import { relativeDate } from 'Helpers/dates';
import classNames from 'classnames';
import PopUpReservationCoach from 'Components/ReservationPopUpCoach/ReservationPopUpCoach';
import ReservationIconBtn from 'Components/ReservationIconBtn/ReservationIconBtn';
// import { Link } from 'react-router-dom';
import MembershipTagV1 from 'Components/MembershipTagV1/MembershipTagV1';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import FeatureBadge from 'Components/FeatureBadge/FeatureBadge';
import { fileNames, HIGHLIGHT_TAG } from 'Constants/imageUrls';
import { FEATURED_TAG } from 'Components/Listing/components/constants';
import { isSpotLight } from 'Helpers/adActionStatus';
import { WEBP_PNG_TYPE } from 'Constants/images';

const ItemTitle = ({
    price,
    title,
    renderLocationPath,
    mainInfo,
    itemCreationDate,
    categoryId,
    isShowReservationButton, // props for show button reservation when item enabled escrow
    isShowCoachMark, // props for show coachmark when item enabled escrow & user first time visit adpv
    onCloseMarkCoach, // props function to skip or close coachmark when item enabled escrow & user first time visit adpv
    isItemReserved, // disabled button reservation when item is reserved
    escrowTrack,
    sellerMemberType,
    actionButtonComponents,
    showDiscountBadge,
    discountTagValue,
    showFeaturedTag,
    discountedPrice,
    monetizationInfo,
    showBookingBadge
}) => {
    const isMemberTagVisible = sellerMemberType || showDiscountBadge || showFeaturedTag || showBookingBadge;

    return (
        <section className={ css.ItemTitle }>
            {
                isMemberTagVisible && (
                    <div className={ css.memberTagcontainerClassName }>
                        <MembershipTagV1
                            type={ sellerMemberType || '' }
                            iconClassName={ css.iconClassName }
                        />
                        {
                            isSpotLight(monetizationInfo) ? <ImageWrapper
                                fileName={ fileNames.SPOTLIGHT_BADGE }
                                types={ WEBP_PNG_TYPE }
                                className={ css.spotlightBadge }
                                data-aut-id="spotlightBadge"
                            /> : showFeaturedTag && <ImageWrapper
                                fileName={ `https://statics.olx.co.id/${HIGHLIGHT_TAG}` }
                                className={ classNames(css.highlightImage) }
                                alt={ FEATURED_TAG.ALT }
                            />
                        }
                        {showDiscountBadge && <FeatureBadge data-aut-id="discountBadge" showIcon className={ css.discountBadgeClassName } size="md" discountText={ `DISKON ${discountTagValue || '-'}` } />}
                        {showBookingBadge && <FeatureBadge data-aut-id="bookingBadge" className={ css.bookingBadge } size="md" discountText={ 'BOOKING AMAN' } />}
                    </div>
                )
            }
            <div className={ classNames(css.titleContainer, { [css.hasMemberTag]: isMemberTagVisible }) }>
                <div className={ css.priceContainer }>
                    {
                        showDiscountBadge && <div className={ css.strikeThroughPriceValue } data-aut-id="strikeThroughPrice">{price}</div>
                    }
                    <span
                        className={ css.price }
                        data-aut-id="itemPrice"
                    >
                        { showDiscountBadge ? discountedPrice : price }
                    </span>
                </div>
                {actionButtonComponents}
            </div>
            { mainInfo && <span className={ css.mainInfo }>{ mainInfo }</span>}
            <h1 data-aut-id="itemTitle" className={ classNames(css.title, { [css.shrink]: !price }) }>
                { title }
            </h1>
            <div className={ css.locationDateWrapper }>
                <div data-aut-id="itemLocation" className={ css.location }>
                    { renderLocationPath() }
                </div>
                <div data-aut-id="itemCreationDate" className={ css.creationDate }>
                    { relativeDate(itemCreationDate) }
                </div>
            </div>
            {

                isShowReservationButton && <div>
                    {isShowCoachMark && <div className={ css.overlay } />}
                    <div id="booking-coach-mark-desktop" className={ classNames(css.buttonReservationContainer, { [css.withOverlay]: isShowCoachMark }) }>
                        {isShowCoachMark && <div >
                            <div className={ css.popup }><PopUpReservationCoach onClose={ onCloseMarkCoach } categoryId={ categoryId } /></div>
                            <div className={ css.blockContent } />
                        </div>}
                        <div
                            className={ css.reservationLink }
                            onClick={ () => escrowTrack() }
                        >
                            <ReservationIconBtn disabledButton={ isItemReserved } />
                        </div>
                    </div>
                </div>
            }
        </section>
    );
};

ItemTitle.propTypes = {
    title: PropTypes.string.isRequired,
    price: PropTypes.string,
    renderLocationPath: PropTypes.func.isRequired,
    mainInfo: PropTypes.string,
    itemCreationDate: PropTypes.string.isRequired,
    isShowCoachMark: PropTypes.bool,
    onCloseMarkCoach: PropTypes.func,
    isShowReservationButton: PropTypes.bool,
    categoryId: PropTypes.string,
    isItemReserved: PropTypes.bool,
    escrowTrack: PropTypes.func,
    sellerMemberType: PropTypes.string,
    actionButtonComponents: PropTypes.element,
    showDiscountBadge: PropTypes.bool,
    discountTagValue: PropTypes.string,
    showFeaturedTag: PropTypes.bool,
    discountedPrice: PropTypes.string,
    monetizationInfo: PropTypes.object,
    showBookingBadge: PropTypes.bool
};

export default ItemTitle;
